import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Pasé de no saber qué diseñar a tener un catálogo completo en días. Todo es copiar, pegar y generar.',
  name: 'Lucas M.',
  role: 'Emprendedor POD'
}, {
  quote: 'Lo que más me ayudó fue la estructura. Dejé de improvisar y empecé a producir en serio.',
  name: 'Sofía R.',
  role: 'Diseñadora'
}, {
  quote: 'Mis diseños ahora tienen mucho más sentido para vender. Antes eran solo ideas lindas.',
  name: 'Martín G.',
  role: 'Marca streetwear'
}, {
  quote: 'El sistema de variaciones es una locura. En una tarde saqué más diseños que en semanas.',
  name: 'Diego F.',
  role: 'Freelance'
}];
export function Testimonials() {
  return <section className="py-12 md:py-20 bg-neutral-900/30 border-y border-neutral-800/50" data-id="element-141">
      <div className="container mx-auto px-4" data-id="element-142">
        <div className="text-center mb-8 md:mb-16" data-id="element-143">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bebas text-5xl md:text-6xl text-white uppercase tracking-wide" data-id="element-144">
            Lo que dicen <span className="text-brand-500" data-id="element-145">los usuarios</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto" data-id="element-146">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 md:p-8" data-id="element-147">
              <div className="flex gap-1 text-brand-500 mb-4" data-id="element-148">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-149" />)}
              </div>
              <p className="text-lg text-neutral-300 italic mb-4 md:mb-6" data-id="element-150">
                "{t.quote}"
              </p>
              <div data-id="element-151">
                <p className="font-bold text-white" data-id="element-152">{t.name}</p>
                <p className="text-sm text-brand-500" data-id="element-153">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}